// extracted by mini-css-extract-plugin
export default {"separator":"PivotBoard_separator__T3G8P"};